import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { Column, Row } from "../utils/MaterialUIComponents";
import { Button } from "@material-ui/core";
import { Link } from "react-router-dom";
import { useData } from "../../context/DataContext";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  appBar: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    minHeight: `100vh`,
    padding: theme.spacing(3),
  },
}));

function Home() {
  const classes = useStyles();
  const { values } = useData();
  return (
    <div className={classes.root}>
      <main className={`centered ${classes.content}`}>
        <Row className="w-100">
          <Column lg={6}>
            <Typography variant="h6">Win $1,000 in Crypto!</Typography>
            <Typography variant="h3">
              The Easy & Fun Way to Learn How to Use Cryptocurrency!
            </Typography>
            <Button
              component={Link}
              to={`/levels/${values[0]}`}
              variant="contained"
              color="primary"
            >
              Start Playing
            </Button>
          </Column>
        </Row>
      </main>
    </div>
  );
}

export default Home;
